import './ScrollUpButton.scss';
import React, { useState, useEffect } from 'react';
import { TiArrowUpThick } from 'react-icons/ti';
import { Button } from 'react-bootstrap';
import { useDevice } from 'lib/hooks/useDevice';

interface ScrollUpButtonProps {
    bottomOffset?: string;
}

const ScrollUpButton = ({
    bottomOffset = '0'
}: ScrollUpButtonProps) => {
    const { isDesktop } = useDevice();
    const [showScrollUpButton, setShowScrollUpButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 300) {
                setShowScrollUpButton(true);
            } else {
                setShowScrollUpButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div style={{ position: 'sticky', bottom: bottomOffset, marginTop: '15px', pointerEvents: 'none', zIndex: 1 }}>
            <div className='ScrollUpButton'>
                {
                    showScrollUpButton && (
                        <Button onClick={scrollToTop}>
                            {isDesktop ? 'Powróć na górę' : <TiArrowUpThick />}
                        </Button>
                    )
                }
            </div>
        </div>
    );
};

export default ScrollUpButton;
